import { combineReducers } from 'redux'

import account from 'state/account'

import ads from 'state/ads'

import app from 'state/app'

import field from 'state/field'

import map from 'state/map'

import farm from 'state/farm'

import cropVariety from 'state/crop-variety'

import crop from 'state/crop'

import brand from 'state/brand'

import equipment from 'state/equipment'

import hardware from 'state/hardware'

import headers from 'state/headers'

import integrations from 'state/integrations'

import client from 'state/client'

import harvest from 'state/harvest'

import job from 'state/job'

import notification from './notification'

import marker from './marker'

import ordersReducer from '../orders'

import type { Account } from 'state/account'

import type { Ads } from 'state/ads'

import type { Hardware } from 'state/hardware'

import type { Equipment } from 'state/equipment'

import type { Header } from 'state/headers'

import type { Crop } from 'state/crop'

import type { Client } from 'state/client'

import type { Farm } from 'state/farm'

import type { Harvest } from 'state/harvest'

import type { Integrations } from 'state/integrations'

import type { Brand } from 'state/brand'

import type { Field } from 'state/field'

import type { ApplicationStatus } from 'state/app'

import type { Map } from 'state/map'

import type { CropVariety } from 'state/crop-variety'

import type { Job } from 'state/job'

import { type Notification } from 'state/notification'

import { type MarkerState } from 'state/marker'

import type { OrdersState } from '../orders'

declare module 'state/index.js' {
  export type AppState = {
    account: Account
    ads: Ads
    app: ApplicationStatus
    field: Field
    map: Map
    farm: Farm
    cropVariety: CropVariety
    crop: Crop
    brand: Brand
    equipment: Equipment
    hardware: Hardware
    headers: Header
    integrations: Integrations
    client: Client
    harvest: Harvest
    job: Job
    notification: Notification
    marker: MarkerState
    orders: OrdersState
  }
}
const state = combineReducers({
  account,
  ads,
  app,
  field,
  map,
  farm,
  cropVariety,
  crop,
  brand,
  equipment,
  hardware,
  headers,
  integrations,
  client,
  harvest,
  job,
  notification,
  marker,
  orders: ordersReducer,
})
export default state
